import { render } from "./LoaderPin.vue?vue&type=template&id=540a0450"
const script = {}
script.render = render

export default script